import { render } from "./MessagesTimeLine.vue?vue&type=template&id=54a0ef5f"
import script from "./MessagesTimeLine.vue?vue&type=script&lang=js"
export * from "./MessagesTimeLine.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__